// libraries
import { ContractType } from '@makemydeal/dr-dash-types';
import type { LenderListState, StateTree } from '@makemydeal/dr-dash-types';

import { getCreditDecisionLender } from './offerRedux';

export const getLenderList = (state: StateTree): LenderListState => {
    return state.lenderList || [];
};

export const isSelectedLenderPaperLender = (state: StateTree): boolean => {
    const selectedLender = getCreditDecisionLender(state);
    if (!selectedLender?.id) return false;
    const lender = getLenderList(state).find((l) => l.lenderId === selectedLender.id);
    return lender?.contractType === ContractType.Paper;
};
